import { ILayerData, TextLayer } from 'types';

const constructTextLayerData = async (layer: TextLayer): Promise<ILayerData<TextLayer>> => ({
  layer: await layer.getParams(false),
  mimeType: layer.mimeType,
});

export default constructTextLayerData;
